import dynamic from 'next/dynamic';

import AUS from './components/UsPage/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import { useGlobal } from '@/utils/useGlobal';
import B from './components/UsPage/B';
import C from './components/UsPage/C';
import D from './components/UsPage/D';
import E from './components/UsPage/E';
import F from './components/UsPage/F';
import G from './components/UsPage/G';
import I from './components/UsPage/I';
import R from './components/UsPage/H';
import FooterTcA from './components/UsPage/FooterTcA';
import ForumEntry from '@elem/compCommon/CommunityEntry';
import SceneProducts from '@elem/compCommon/SceneProducts';
import { COST_SAVING_AU_SCENE_PRODUCTS, COST_SAVING_AU_SCENE_PRODUCTS_MORE } from './config/sceneProducts.au';

export default function VanlifeRoadtrips() {
    // const { locale = '', query } = useRouter();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const { useState, useLang, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('costsaving-new');

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#cost-saving-C' },
            { text: t('secC_btn2'), link: '#cost-saving-E' },
            // { text: t('secC_btn3'), link: '#cost-saving-J' },
            // { text: t('secC_btn4'), link: '#cost-saving-L' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`cost-saving ${css['cost-saving']}`} style={{ paddingBottom: 0 }}>
            {/* <PDBar></PDBar> */}
            <AUS />
            <B />
            <D />
            <SceneProducts
                id="cost-saving-products-more"
                cards={COST_SAVING_AU_SCENE_PRODUCTS_MORE}
                texts={{
                    buyNow: t('common_card_buyNow'),
                    more: t('common_card_more'),
                    out: t('common_card_out'),
                    listName: 'Products',
                }}
                maxWidth={1440}
            />

            <F />
            <SceneProducts
                id="cost-saving-products"
                cards={COST_SAVING_AU_SCENE_PRODUCTS}
                texts={{
                    buyNow: t('common_card_buyNow'),
                    more: t('common_card_more'),
                    out: t('common_card_out'),
                    listName: 'Products',
                }}
                maxWidth={1440}
            />
            <I />

            {/* <FooterTcA /> */}
            <ForumEntry />
            <R />

            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}

            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
